import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { datasheetPageQueryOptions } from "~/app/api/pageData/datasheetPageQuery";
import type { DatasheetPageInitialData } from "~/app/api/pageData/datasheetPageInitialData";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { createDataSheetPage } from "~/pages/DataSheetPage/DataSheetPage";
import { StaticPageHeader } from "~/features/navigation/components/StaticPageHeader/StaticPageHeader";

export const DATASHEET_ROUTE_PATH = "/datasheet/$productDesignation";

function DatasheetRoute() {
  const result = useLoaderData({
    from: DATASHEET_ROUTE_PATH,
  }) as PageInitialData<DatasheetPageInitialData>;
  const shellProps = useStorefrontShellProps();
  const data = result.data;

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata} header={<StaticPageHeader />}>
      {data ? createDataSheetPage(data.product) : null}
    </StorefrontShellFrame>
  );
}

export async function loadDatasheetPageData(context: { queryClient: QueryClient }, productDesignation: string) {
  const result = await context.queryClient.ensureQueryData(datasheetPageQueryOptions(productDesignation));

  return unwrapPageInitialData(result);
}

export const datasheetRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: DATASHEET_ROUTE_PATH,
  loader: async ({ context, params }) => loadDatasheetPageData(context, params.productDesignation),
  component: DatasheetRoute,
});
